import { useStore } from '@tanstack/react-form'
import { routes } from 'commons/constants/routes'
import { ButtonGroup, Layer, LeaveConfirmation, Link, Page, PageFace, Panel } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { Footer } from 'ui/temp/Footer'

import { QuarterInfoSection } from './components/QuarterInfoSection'
import { RelationshipDetails } from './components/RelationshipDetails'
import { useAnnualReviewSalesDepositsContext } from './context/AnnualReviewSalesDepositsContext'
import { AnnualReviewSalesDepositsContextProvider } from './context/AnnualReviewSalesDepositsContextProvider'

import { s } from './styles'

const AnnualReviewSalesDeposits = () => {
  const { id, formApi, companyId, annualReviewId } = useAnnualReviewSalesDepositsContext()

  const d = useStore(formApi.store, (s) => s.isDirty && !s.isSubmitting && !s.isSubmitted)

  return (
    <LeaveConfirmation preventLeaving={d}>
      <Page
        face={PageFace.SECONDARY}
        title="Sales & Deposit Summary"
        subTitle={`SDS-${id}`}
        footer={
          <Footer>
            <ButtonGroup margin="small">
              <Link
                to={routes.bank.annualReview.details}
                params={{ companyId: companyId.toString(), id: annualReviewId.toString() }}
              >
                <Button face="secondary">Cancel</Button>
              </Link>
              <Button
                face="primary"
                onClick={formApi.handleSubmit}
                disabled={useStore(formApi.store, (s) => !s.isDirty || !s.isFieldsValid)}
              >
                Submit
              </Button>
            </ButtonGroup>
          </Footer>
        }
      >
        <Layer rounded shadowed>
          <Panel collapsible={false} title="Edit Information">
            <s.Wrapper>
              <RelationshipDetails />
              <QuarterInfoSection />
            </s.Wrapper>
          </Panel>
        </Layer>
      </Page>
    </LeaveConfirmation>
  )
}

const AnnualReviewSalesDepositsWrapper = () => (
  <AnnualReviewSalesDepositsContextProvider>
    <AnnualReviewSalesDeposits />
  </AnnualReviewSalesDepositsContextProvider>
)

export default AnnualReviewSalesDepositsWrapper
